import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Chip, Typography } from "@mui/material";
import moment from "moment";
import { getPuzzleTypeById } from "../../pzl_common/PuzzleTypeConstants";

const cellCenterSx = { display: "flex", alignItems: "center", height: "100%", width: "100%" };

export function getPubTabLogsColumns() {
    return [
        {
            field: "scheduleCron",
            headerName: "Schedule",
            width: 100,
            minWidth: 140,
            valueGetter: (value, row) => row.schedule?.cron ?? "",
            renderCell: (params) => (
                <Box sx={cellCenterSx}>
                    <Typography variant="body2">{params.value ?? ""}</Typography>
                </Box>
            )
        },
        {
            field: "success",
            headerName: "Status",
            width: 100,
            renderCell: (params) => (
                <Box sx={cellCenterSx}>
                    {params.value === true ? (
                        <Chip size="small" icon={<CheckCircleIcon />} label="Success" color="success" />
                    ) : params.value === false ? (
                        <Chip size="small" icon={<ErrorIcon />} label="Failed" color="error" />
                    ) : (
                        <Chip size="small" icon={<InfoOutlinedIcon />} label="Info" color="default" variant="outlined" />
                    )}
                </Box>
            )
        },
        {
            field: "publisherType",
            headerName: "Type",
            width: 100,
            minWidth: 120,
            renderCell: (params) => (
                <Box sx={cellCenterSx}>
                    <Typography variant="body2">{params.value ?? ""}</Typography>
                </Box>
            )
        },
        {
            field: "puzzleType",
            headerName: "Puzzle Type",
            width: 100,
            minWidth: 130,
            valueGetter: (value) => (value ? (getPuzzleTypeById(value)?.name ?? value) : ""),
            renderCell: (params) => (
                <Box sx={cellCenterSx}>
                    <Typography variant="body2">{params.value ?? ""}</Typography>
                </Box>
            )
        },
        {
            field: "language",
            headerName: "Language",
            width: 90,
            renderCell: (params) => (
                <Box sx={cellCenterSx}>
                    <Typography variant="body2">{params.value ?? ""}</Typography>
                </Box>
            )
        },
        {
            field: "message",
            headerName: "Message",
            flex: 1,
            minWidth: 180,
            renderCell: (params) => (
                <Box sx={{ ...cellCenterSx, py: 0.5 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            width: "100%"
                        }}
                    >
                        {params.value ?? ""}
                    </Typography>
                </Box>
            )
        },
        {
            field: "createdAt",
            headerName: "Created At",
            width: 100,
            minWidth: 165,
            valueFormatter: (value) => (value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : ""),
            renderCell: (params) => (
                <Box sx={cellCenterSx}>
                    <Typography variant="body2">{params.formattedValue ?? ""}</Typography>
                </Box>
            )
        }
    ];
}
